
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6vx1i", function(module, exports) {
/* ReadingAidsAcronymsHighlighter.tsx generated by @compiled/babel-plugin v0.36.1 */ 
var $42omo = parcelRequire("42omo");


var $gMc0m = parcelRequire("gMc0m");


var $3IBnw = parcelRequire("3IBnw");


var $aJv6Q = parcelRequire("aJv6Q");


var $jmjWc = parcelRequire("jmjWc");


var $bjVRl = parcelRequire("bjVRl");

const $7618df873c80ee96$var$readingAidsPopupPortalContainerId = 'reading-aids-portal-container';

const $7618df873c80ee96$var$ReadingAidsSpotlightWrapper = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "7h_DJ",
    name: "ReadingAidsSpotlightWrapper",
    loader: async ()=>(await (parcelRequire("lhrLa"))).ReadingAidsSpotlightWrapper
});

const $7618df873c80ee96$var$ReadingAidsPopup = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "fofjy",
    name: "ReadingAidsPopup",
    loader: async ()=>(await (parcelRequire("fXZMc"))).ReadingAidsPopup
}); // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $7618df873c80ee96$var$Container = /*#__PURE__*/ (0, $42omo.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $gMc0m.default)([
            "_1reoewfl _18m9ewfl _kqswh2mm _1pby1o8a",
            __cmplp.className
        ])
    });
});
const $7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent = ({ contentId: contentId })=>{
    const { showPopup: showPopup, autohighlightContext: autohighlightContext, autohighlightSelectionRect: autohighlightSelectionRect, autohighlightText: autohighlightText, sessionId: sessionId, showSpotlight: showSpotlight } = (0, $bjVRl.useReadingAidsState)();
    const portalContainerRef = (0, $42omo.useRef)(null);
    const { hideAutohighlightPopup: hideAutohighlightPopup, setPortalContainerRef: setPortalContainerRef } = (0, $bjVRl.useReadingAidsActions)();
    const selectionRect = {
        top: autohighlightSelectionRect.top,
        left: autohighlightSelectionRect.left,
        width: autohighlightSelectionRect.width,
        height: autohighlightSelectionRect.height
    };
    (0, $42omo.useEffect)(()=>{
        setPortalContainerRef({
            portalContainerRef: portalContainerRef
        });
    }, [
        portalContainerRef,
        setPortalContainerRef
    ]);
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$Container, {
        id: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        ref: portalContainerRef
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsSpotlightWrapper, {
        contentId: contentId,
        selectionRect: selectionRect,
        showSpotlight: showSpotlight
    }), showPopup && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($42omo))).createElement($7618df873c80ee96$var$ReadingAidsPopup, {
        selectedText: autohighlightText,
        additionalContext: autohighlightContext,
        selectionRect: selectionRect,
        isReadingAidsOpen: showPopup,
        onResult: ()=>{},
        onClose: hideAutohighlightPopup,
        contentId: contentId,
        popupPortalContainerId: $7618df873c80ee96$var$readingAidsPopupPortalContainerId,
        isAutohighlighted: true,
        sessionId: sessionId
    }));
};
const $7618df873c80ee96$export$ffdc57aecb97ae41 = (0, $aJv6Q.withErrorBoundary)({
    attribution: (0, $3IBnw.Attribution).KNOWLEDGE_DISCOVERY
})($7618df873c80ee96$var$ReadingAidsAcronymsHighlighterComponent);
module.exports["ReadingAidsAcronymsHighlighter"] = $7618df873c80ee96$export$ffdc57aecb97ae41;

});

parcelRegister("lhrLa", function(module, exports) {

let $f7e0b7fe1134fa59$var$load = (parcelRequire("4mJKd"))(5);
module.exports = $f7e0b7fe1134fa59$var$load("fdsim").then(()=>parcelRequire('jgOPc'));

});

parcelRegister("fXZMc", function(module, exports) {

let $b9fc493b07c9e189$var$load = (parcelRequire("4mJKd"))(5);
module.exports = Promise.all([
    $b9fc493b07c9e189$var$load("h3ABO"),
    $b9fc493b07c9e189$var$load("fTLUk"),
    $b9fc493b07c9e189$var$load("djHM5"),
    $b9fc493b07c9e189$var$load("eJQji"),
    $b9fc493b07c9e189$var$load("2YffH"),
    $b9fc493b07c9e189$var$load("2VmDq"),
    $b9fc493b07c9e189$var$load("6mHrv"),
    $b9fc493b07c9e189$var$load("awWN9"),
    $b9fc493b07c9e189$var$load("9CYct"),
    $b9fc493b07c9e189$var$load("9QUT8"),
    $b9fc493b07c9e189$var$load("5zRul"),
    $b9fc493b07c9e189$var$load("hZtKG"),
    $b9fc493b07c9e189$var$load("dkqvW"),
    $b9fc493b07c9e189$var$load("lVO3w"),
    $b9fc493b07c9e189$var$load("hyzoX"),
    $b9fc493b07c9e189$var$load("h9Ed7"),
    $b9fc493b07c9e189$var$load("eBRUf"),
    $b9fc493b07c9e189$var$load("kbRvk"),
    $b9fc493b07c9e189$var$load("tKhaz"),
    $b9fc493b07c9e189$var$load("9Vh0G"),
    $b9fc493b07c9e189$var$load("hBIgN"),
    $b9fc493b07c9e189$var$load("cD6Zr"),
    $b9fc493b07c9e189$var$load("9wzNh"),
    $b9fc493b07c9e189$var$load("8YSo7"),
    $b9fc493b07c9e189$var$load("3Zfzp"),
    $b9fc493b07c9e189$var$load("9ldRJ"),
    $b9fc493b07c9e189$var$load("50ame"),
    $b9fc493b07c9e189$var$load("liX7c"),
    $b9fc493b07c9e189$var$load("cvhFw"),
    $b9fc493b07c9e189$var$load("ebWFc"),
    $b9fc493b07c9e189$var$load("6iz6l"),
    $b9fc493b07c9e189$var$load("4SCW2"),
    $b9fc493b07c9e189$var$load("8bXcu"),
    $b9fc493b07c9e189$var$load("1YiFu"),
    $b9fc493b07c9e189$var$load("hv4mn"),
    $b9fc493b07c9e189$var$load("Wowvf"),
    $b9fc493b07c9e189$var$load("dek7I"),
    $b9fc493b07c9e189$var$load("3SmkN"),
    $b9fc493b07c9e189$var$load("dYtBN"),
    $b9fc493b07c9e189$var$load("kNV5Y"),
    $b9fc493b07c9e189$var$load("6wr18"),
    $b9fc493b07c9e189$var$load("kjZZD"),
    $b9fc493b07c9e189$var$load("jytCl"),
    $b9fc493b07c9e189$var$load("iGhIB"),
    $b9fc493b07c9e189$var$load("3JSgG"),
    $b9fc493b07c9e189$var$load("37ldp"),
    $b9fc493b07c9e189$var$load("ffEVr"),
    $b9fc493b07c9e189$var$load("dRpV3"),
    $b9fc493b07c9e189$var$load("28arV"),
    $b9fc493b07c9e189$var$load("hhss7"),
    $b9fc493b07c9e189$var$load("jYUNl"),
    $b9fc493b07c9e189$var$load("foy8I"),
    $b9fc493b07c9e189$var$load("jY21r"),
    $b9fc493b07c9e189$var$load("dP7ao"),
    $b9fc493b07c9e189$var$load("hogcU"),
    $b9fc493b07c9e189$var$load("i8eeg"),
    $b9fc493b07c9e189$var$load("iFdoJ"),
    $b9fc493b07c9e189$var$load("7EorR"),
    $b9fc493b07c9e189$var$load("avRkh")
]).then(()=>parcelRequire('cmXz4'));

});


//# sourceMappingURL=ReadingAidsAcronymsHighlighter.870e6a8d.js.map
